import * as Actions from '../../actions/users/type';

const initialState = {
  loading: false,
  workflow: null,
  storedWorkflow: null,
  error: null,
};

export const workflowReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.SET_WORKFLOW_REQUEST:
      return { ...state, loading: true };
    case Actions.SET_WORKFLOW_SUCCESS:
      return { ...state, loading: false, ...action.payload };
    case Actions.SET_WORKFLOW_FAIL:
      return { ...state, loading: false, error: action.payload };
    case Actions.GET_WORKFLOW_REQUEST:
      return { ...state, loading: true };
    case Actions.GET_WORKFLOW_SUCCESS:
      return {
        ...state,
        loading: false,
        storedWorkflow: action.payload.workflow?.length
          ? action.payload.workflow
          : null,
      };
    case Actions.GET_WORKFLOW_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
